import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import Home from './pages/Home'
import SearchResults from './pages/SearchResults';
import Produtos from './pages/Produtos';
import Institucional from './pages/Institucional';
import Suporte from './pages/Suporte';
import ProdutoIndividual from './pages/ProdutoIndividual';
import Categoria from './pages/Categoria';
import { ProductProvider } from './Context/ProductContext';
import TermosCondicoes from './pages/TermosCondicoes';
import Catalogo from './pages/Catalogo';
import CanalArquiteto from './pages/CanalArquiteto';
import Login from './pages/Login';
import LuceLineare from './pages/LuceLineare';
import CanalInstalador from './pages/CanalInstalador';
import Showroom from './pages/Showroom';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <HelmetProvider>
    <ProductProvider>
    <Router>
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/produtos" element={<Produtos />} />
          <Route path="/catalogo" element={<Catalogo />} />
          <Route path="/categoria/:categoryName" element={<Categoria />} />
          <Route path="/produtos/:categoryName/:productId" element={<ProdutoIndividual />} />
          <Route path="/institucional" element={<Institucional />} />
          <Route path="/suporte" element={<Suporte />} />
          <Route path="/canal-do-arquiteto" element={<CanalArquiteto />} />
          <Route path="/termos-e-condicoes" element={<TermosCondicoes />} />
          <Route path="/colecao-luce-lineare" element={<LuceLineare />} />
          <Route path="/canal-do-instalador" element={<CanalInstalador />} />
          <Route path="/showroom" element={<Showroom />} />
        </Routes>
    </Router>
    </ProductProvider>
    </HelmetProvider>
  );
}

export default App;